// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"00914ff1","95":"97547a9a","255":"264aca7a","262":"4c00620a","342":"635dda0c","453":"02bc5379","457":"27a87f42","503":"7b84ea57","678":"7f9fa84a","679":"b8448f63"}[chunkId] + ".chunk.js";
};